"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.setAccessAuth = exports.clearFaceTecSession = exports.setFaceTecSession = exports.clearFaceTecSessions = exports.setFaceTecEditSession = exports.setFaceTecViewSession = exports.setFaceTecAuthorized = exports.setNewRegistration = exports.setUserToken = exports.setIsLoading = exports.setUser = exports.devMode = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
exports.devMode = process.env.NODE_ENV !== "production";
const initialState = {
    user: {
        email: "",
        cell_number: "",
        password: "",
        confirm_password: "",
        name: "",
        surname: "",
        reset_password_otp: undefined,
        facetecDBRef: null,
        remember_me: true,
    },
    token: "",
    isLoading: false,
    newRegistration: false,
    faceTecAuthorized: false,
    faceTecSessions: {
        view: null,
        edit: null,
    },
    faceTecSession: null,
    accessAuth: null,
};
const slice = (0, toolkit_1.createSlice)({
    name: "user",
    initialState,
    reducers: {
        setUser: (state, action) => {
            state.user = action.payload;
        },
        setIsLoading: (state, action) => {
            state.isLoading = action.payload;
        },
        setUserToken: (state, action) => {
            state.token = action.payload;
        },
        setFaceTecAuthorized: (state, action) => {
            state.faceTecAuthorized = action.payload;
        },
        // New dual-session actions
        setFaceTecViewSession: (state, action) => {
            state.faceTecSessions.view = action.payload;
        },
        setFaceTecEditSession: (state, action) => {
            state.faceTecSessions.edit = action.payload;
        },
        clearFaceTecSessions: (state) => {
            state.faceTecSessions.view = null;
            state.faceTecSessions.edit = null;
        },
        // Legacy single session actions (kept for backwards compatibility)
        setFaceTecSession: (state, action) => {
            var _a, _b, _c, _d;
            state.faceTecSession = action.payload;
            // Also populate new structure based on session type
            if (((_a = action.payload) === null || _a === void 0 ? void 0 : _a.session_type) === "VIEW" || ((_b = action.payload) === null || _b === void 0 ? void 0 : _b.session_type) === "LOGIN") {
                state.faceTecSessions.view = action.payload;
            }
            else if (((_c = action.payload) === null || _c === void 0 ? void 0 : _c.session_type) === "EDIT" || ((_d = action.payload) === null || _d === void 0 ? void 0 : _d.session_type) === "SIGN") {
                state.faceTecSessions.edit = action.payload;
            }
        },
        clearFaceTecSession: (state) => {
            state.faceTecSession = null;
            state.faceTecSessions.view = null;
            state.faceTecSessions.edit = null;
        },
        setNewRegistration: (state, action) => {
            state.newRegistration = action.payload;
        },
        setAccessAuth: (state, action) => {
            state.accessAuth = action.payload;
        },
    },
});
_a = slice.actions, exports.setUser = _a.setUser, exports.setIsLoading = _a.setIsLoading, exports.setUserToken = _a.setUserToken, exports.setNewRegistration = _a.setNewRegistration, exports.setFaceTecAuthorized = _a.setFaceTecAuthorized, exports.setFaceTecViewSession = _a.setFaceTecViewSession, exports.setFaceTecEditSession = _a.setFaceTecEditSession, exports.clearFaceTecSessions = _a.clearFaceTecSessions, exports.setFaceTecSession = _a.setFaceTecSession, exports.clearFaceTecSession = _a.clearFaceTecSession, exports.setAccessAuth = _a.setAccessAuth;
exports.default = slice.reducer;
